import type { Consumable } from '@/types/drilling';

export const PRICING_KEY = 'strataworks-consumable-pricing';

export interface ConsumablePrice {
    id: string;
    type: string;
    subType: string;
    diameter: string;
    manufacturer: string;
    unitCost: string;
}

export function loadPricing(): ConsumablePrice[] {
    try {
        return JSON.parse(localStorage.getItem(PRICING_KEY) ?? '[]');
    } catch {
        return [];
    }
}

export function findUnitCost(consumable: Consumable, pricing: ConsumablePrice[]): number {
    if (pricing.length === 0) return 0;

    if (consumable.type === 'drill-bit') {
        const diam = consumable.bitDiameter ? `${consumable.bitDiameter}mm` : '';
        const btype = consumable.bitType ?? '';
        let m = pricing.find(
            (p) =>
                p.type === 'drill-bit' &&
                p.subType === btype &&
                p.diameter === diam &&
                p.manufacturer === consumable.manufacturer
        );
        if (!m)
            m = pricing.find(
                (p) => p.type === 'drill-bit' && p.subType === btype && p.diameter === diam
            );
        if (!m) m = pricing.find((p) => p.type === 'drill-bit');
        return m ? Number(m.unitCost) || 0 : 0;
    }

    if (consumable.type === 'hammer') {
        const diam = consumable.bitDiameter ? `${consumable.bitDiameter}mm` : '';
        let m = pricing.find(
            (p) =>
                p.type === 'hammer' &&
                p.subType.includes(diam) &&
                p.manufacturer === consumable.manufacturer
        );
        if (!m) m = pricing.find((p) => p.type === 'hammer' && p.subType.includes(diam));
        if (!m) m = pricing.find((p) => p.type === 'hammer');
        return m ? Number(m.unitCost) || 0 : 0;
    }

    const m = pricing.find((p) => p.type === consumable.type);
    return m ? Number(m.unitCost) || 0 : 0;
}
